import React, {useEffect, useState} from 'react';
import DocumentTemplateFillOutComponent from 'features/documentTemplate/DocumentTemplateFillOutComponent';
import {useDispatch} from 'react-redux';
import {AppDispatch} from '../../store/store';
import {DocumentTemplate} from '../../types/documentTemplate';
import {useParams} from 'react-router-dom';
import {DocumentTemplateSolutionThunks} from '../../features/documentTemplateSolution/documentTemplateSolutionThunks';

const DocumentTemplateUserFillOutPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [documentTemplate, setDocumentTemplate] = useState<DocumentTemplate>(
    new DocumentTemplate({}),
  );
  const [solutionId, setSolutionId] = useState<string>('');
  const [ownerType, setOwnerType] = useState<
    'UserApplication' | 'UserEvaluation'
  >('UserApplication');
  const [ownerId, setOwnerId] = useState<string>('');
  const {id} = useParams<{id: string}>();

  useEffect(() => {
    const loadData = async () => {
      const search = {
        where: {
          id: {
            operator: '==',
            value: id,
          },
        },
      };
      const response = await dispatch(
        DocumentTemplateSolutionThunks.index({search: search}),
      );
      if (response.payload) {
        const documentTemplate = new DocumentTemplate(
          response.payload.data[0].snapshot,
        );
        setDocumentTemplate(documentTemplate);
        setSolutionId(response.payload.data[0].id);
        setOwnerType(response.payload.data[0].ownerType);
        setOwnerId(response.payload.data[0].ownerId);
      } else {
        alert('Could not fetch template data.');
      }
    };
    loadData();
  }, [id, ownerType]);

  return (
    <div>
      <DocumentTemplateFillOutComponent
        mode={'view'}
        buttonText={'Complete'}
        documentTemplate={documentTemplate}
        solutionId={solutionId}
        ownerType={ownerType}
        ownerId={ownerId}
      />
    </div>
  );
};

export default DocumentTemplateUserFillOutPage;
